/* Rquiere de mixin.js */

var bookstore = {
    data() {
        return {
            listBookstores: [],
            loadingChurchs: false,
            objectBookstore: {
                exist: 0,
                id: 0,
                name: '',
                store_id: null,
                store: {},
                client_id: null,
                client: {},
                price_list_id: null,
                price_list: {},
                status_id: null,
                status: {},
                created_at: null,
                updated_at: null,
            }
        }
    },
    computed: {
    },
    filters: {
    },
    methods: {
        clearObjectBookstore() {
            this.objectBookstore.exist = 0
            this.objectBookstore.id = 0
            this.objectBookstore.name = ''
            this.objectBookstore.store_id = null
            this.objectBookstore.store = {}
            this.objectBookstore.client_id = null
            this.objectBookstore.client = {}
            this.objectBookstore.price_list_id = null
            this.objectBookstore.price_list = {}
            this.objectBookstore.status_id = null
            this.objectBookstore.status = {}
            this.objectBookstore.created_at = null
            this.objectBookstore.updated_at = null
        },
        getAllBookstoreByUserLogin() {
            this.loadingChurchs = true
            let url = this.getApiBackend + 'userLogin/bookstores'
            this.axiosActionIS(url, 'GET', 'getAllBookstoreByUserLoginResult')
        },
        getAllBookstoreByUserLoginResult(response) {
            if (response.data.success == true) {
                this.listBookstores = response.data.data
            }
            this.getAllBookstoreByUserLoginResultLocal(response)
        },
        getAllBookstoreByUserLoginResultLocal(response) {
            console.log('getAllBookstoreByUserLoginResultLocal no desarrollado', response)
        },
        setObjectBookstore(item) {
            this.clearObjectBookstore()
            let newItem = Object.create(item)
            for (const property in newItem) {
                this.objectBookstore[property] = newItem[property]
            }
        },
    },
};

export default bookstore;